import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

interface TpProps {
  referenceElement?: HTMLElement | null;
  offsetX?: number;
  offsetY?: number;
  blurTarget?: HTMLElement | null;
  disableBlur?: boolean;
  keepBlur?: boolean;
  children: React.ReactNode;
  close: () => void;
}

export function ModalPortal(props: TpProps) {
  const docEl = document.getElementById('modalPortalRoot');

  if (!docEl) return null;

  let theBlurTarget = props.blurTarget;
  if (!theBlurTarget) theBlurTarget = document.getElementById('normalAppWrapper');

  useEffect(() => {
    if (theBlurTarget && !props.disableBlur) theBlurTarget.style.filter = 'blur(3px)';
    // on close function
    return () => {
      if (theBlurTarget && !props.keepBlur) theBlurTarget.style.filter = '';
    };
  });

  const popupStyle = {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  };

  if (props.referenceElement) {
    const rect = props.referenceElement.getBoundingClientRect();
    popupStyle.top = `${rect.bottom + (props.offsetY || 0)}px`;
    popupStyle.left = `${rect.left + (props.offsetX || 0)}px`;
    popupStyle.transform = '';
  }

  const wrapper = (
    <div
      id="modalPortalWrapper"
      style={{ width: '100vw', height: '100vh', backgroundColor: 'rgba(255,255,255,0.35)', position: 'absolute' }}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) {
          props.close();
        }
      }}
    >
      <div
        style={{
          position: 'absolute',
          backgroundColor: 'var(--light-color)',
          boxShadow: '0 0 70px rgba(0,0,0,0.25)',
          margin: 0,
          ...popupStyle,
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
        onMouseDown={(e) => {
          e.stopPropagation();
        }}
      >
        {props.children}
      </div>
    </div>
  );
  return createPortal(wrapper, docEl);
}
